module.exports = __webpack_public_path__ + "img/admin-agent-stats.a495f9b5.png";